// AI-CONTEXT: See docs/features/compare-two-periods.md
//
// True when a range has both bounds set and the start is after the end — an
// invalid range the period control must refuse to save (a fetch on it would
// silently match nothing). ISO 'YYYY-MM-DD' strings compare correctly with >,
// so no Date parsing is needed. Half-open (one bound null) is never inverted.

/**
 * @param {{start?: string|null, end?: string|null}|null|undefined} range
 * @returns {boolean}
 */
const isRangeInverted = (range) => {
    const start = range?.start || null
    const end = range?.end || null
    if (!start || !end) return false
    return start > end
}

export default isRangeInverted
